module.exports = __webpack_public_path__ + "img/rule deal banker.8e87189a.png";